import { shopwareApiClient } from '$lib/api/shopwareApi.js';
import type { ApiRequestParams, ApiReturnType } from '$lib/api/shopwareApi.js';
import type { ShopContext } from '$lib/context.js';

export class ContactApi {
    public static sendContactMail(
        data: ApiRequestParams<'sendContactMail'>,
        shopContext?: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'sendContactMail'>> {
        return shopwareApiClient.invoke('sendContactMail post /contact-form', data, {
            fetchImplementation,
            shopContext: shopContext ?? ({ shopwareLanguage: {}, storeContext: {} } as ShopContext)
        });
    }
}
